// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"914":"be9a4aa4","933":"d232922c"}[chunkId] + ".chunk.js";
};